import { Col, Row } from "react-bootstrap";
import MaterialIcon, {
  MtIcon,
} from "../../../../../shared/oversight-core/ui-elements/material-icon/material-icon";

interface IProps {
  icon: MtIcon;
  name: string;
  count: number;
  bgColor?: string;
}

const SolarHistoryCard = (props: IProps) => {
  const { icon, name, count, bgColor } = props;

  return (
    <Row
      className={`${
        bgColor ? bgColor : `theme-card-6`
      } align-items-center rounded-3 mx-0 px-1 py-2 h-100`}
    >
      <Col>
        <Row className="align-items-center">
          <Col className="col-auto pe-0">
            <MaterialIcon
              icon={icon}
              color={bgColor ? `#ffffff` : `var(--color-component-icon)`}
            />
          </Col>
          <Col
            className={`${
              bgColor ? `text-white` : `text-label`
            } font-weight-500 font-size-14`}
          >
            {name}
          </Col>
        </Row>
      </Col>
      <Col
        className={`col-auto ${
          bgColor ? `text-white` : `text-label`
        } font-weight-600 font-size-14`}
      >
        x{count}
      </Col>
    </Row>
  );
};

export default SolarHistoryCard;
